export const getRedeemThresholds = (state) => state.redeemThresholds.thresholds;
